const PRODUCTION_API_BASE = "https://housemind-backend.onrender.com/api";

function isLocalHost(hostname = "") {
  const host = String(hostname).trim().toLowerCase();
  if (["localhost", "127.0.0.1", "::1"].includes(host) || host.endsWith(".local")) {
    return true;
  }

  // Phones and tablets reach the local development server through the
  // computer's private LAN address rather than `localhost`.
  return (
    /^10(?:\.\d{1,3}){3}$/.test(host) ||
    /^192\.168(?:\.\d{1,3}){2}$/.test(host) ||
    /^172\.(?:1[6-9]|2\d|3[01])(?:\.\d{1,3}){2}$/.test(host)
  );
}

function isLocalApiBase(value = "") {
  return /^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])(?::\d+)?\/api\/?$/i.test(value);
}

export function getApiBase() {
  const configured = (process.env.REACT_APP_API_URL || "").trim().replace(/\/$/, "");
  const browserHost = typeof window !== "undefined" ? window.location.hostname : "";
  const runningLocally = !browserHost || isLocalHost(browserHost);

  if (configured && !isLocalApiBase(configured)) {
    return configured;
  }

  if (runningLocally) {
    return "/api";
  }

  return PRODUCTION_API_BASE;
}

export const API_BASE = getApiBase();
